export class Step2 {
    constructor() {}
    intitule = 'stepper.form.mapa_an.step3';

    getspan2 = 'form.mapa_an.getspan2';
    getspan3 = 'form.mapa_an.getspan3';
    getspan4 = 'form.mapa_an.getspan4';
    getspan5 = 'form.mapa_an.getspan5';

    getobjet = 'form.mapa_an.getobjet';
    getclassprincipale = 'form.mapa_an.getclassprincipale';
    getclasssupplementaire_liste_avi_ = 'form.mapa_an.getclasssupplementaire_liste_avi_';
	getnum = 'form.mapa_an.getnum';
    gettypevoie = 'form.mapa_an.gettypevoie';
    getnomvoie = 'form.mapa_an.getnomvoie';
    getcp = 'form.mapa_an.getcp';
    getville = 'form.mapa_an.getville';
    getlieuexecutionlivraison = 'form.mapa_an.getlieuexecutionlivraison';
    getmotclef_liste_avi_ = 'form.mapa_an.getmotclef_liste_avi_';

}
